export default {
  formatAmount (value) {
    if (value === undefined || value === null) return '0'
    else if (Number.isNaN(value)) return value
    else {
      if (Number(value) % 1 > 0) {
        return parseFloat(value).toFixed(2).replace('.', ',')
      } else {
        return value.toString()
      }
    }
  }
}
